// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectAccountOperationMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_ACCOUNOPERATION_MESSAGE)
    this.OperationID;
    this.OperationType;
    this.CounterID;
    this.AccountID;
    this.Amount;
    this.Balance;
    this.CreatedAt;
    this.SettlementDate;
    this.Currency;
    this.Comment;
    this.InstrumentName;
    this.InstrumentTradableId;
    this.Quantity;
    this.OpenPrice;
    this.ClosePrice;
    this.IsBuy;
}

DirectAccountOperationMessage.prototype = Object.create(DirectMessageBase.prototype)


DirectAccountOperationMessage.AccountOperationType =
{
    Trading: 1,
    Deposit: 2,
    Withdraw: 3,
    Brokerage: 4,
    swap: 5,
    MinFeeAdjEquity: 6,
    Blocking: 7,
    Unblocking: 8,
    ManufacturedDividends: 9,
    interest: 10,
    Adjustment: 12,
    dividends: 13,
    StockOperation: 14,
    AccruedInterest: 15,
    Subscribe: 16,
    Transfer: 17,
    Spread: 18,
    Credit: 19,
    Premium: 21,
    DeliveredForward: 22,
    PAMMTransfer: 23,
    DWT: 24,
    ValueAddedTax: 25,
    Exchange: 26,
    SecuritiesTransferTax: 27,
    SettlementFee: 28,
    InvestorProtectionLevy: 29,
    Delivery: 30,
    addliquidityrebate: 31,
    removeliquidityrebate: 32,
    withdrawalfee: 33,
    Markup: 34,
    ClearingVmTransfer: 40,
    Level1DataCharging: 41,
    Level2DataCharging: 42,
    Level3DataCharging: 43,
    DelayedDataCharging: 44,
    NewsCharging: 45,
    MamPerformanceFee: 46,
    MamManagementFee: 47,
    InterestOnCash: 88,
    InterestOnMarginAvailable: 90,
    InterestOnMarginAvailableAndUnsettledCash: 91,
    InterestOnAvailableFunds: 92,
    IntererstOnAvailableFundsAndUnsettledCash: 93,
    OpenOptionPremium: 94,
    CloseOptionPremium: 95,
    TransferFee: 96,
    FixedFee: 97,
    Custodial: 98,
    BalanceCredit: 100,
    BalanceDebit: 101,
    AccruedDividends: 102,
    DividendsTax: 103,
    Funding: 106,
    FundingMarkup: 107
}

DirectAccountOperationMessage.AccountOperationTypeNames = (function ()
{
    let result = {};
    let keys = Object.keys(DirectAccountOperationMessage.AccountOperationType);

    let len = keys.length;

    for (let i = 0; i < len; i++)
        result[DirectAccountOperationMessage.AccountOperationType[keys[i]]] = keys[i];

    return result;
})()